import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Col, Divider, Input, InputNumber, message, Modal, Radio, Row, Select, Typography} from 'antd';
import {get, get_response, post} from "helper/request";
import {isNull, isTrue} from "../utils/utils";
import {cloudProvider} from "utils/const";
import {loadUsers} from "../redux_actions/cases.action";
import {error_manager} from "../helper/error_manager";

class CreateUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: "",
            groupName: "",
            customerName: "",
            organisationName: "",
            deviceDisplayName: "",
            firstName: "",
            password: "",
            allowedCloudUploads: 10,
            createAdminUser: true,
            overrideExistingUser: false,
            adminUsername: "",
            adminPassword: "",
            keyExistsInCloud: false,
            editForm: false,
            hideModal: false,
            all_devices: [],
        }
    }

    componentDidMount() {


        get("/api/cloud_setup_done_check/")
            .then(response => {
                if (isTrue(response['key_exists'])) {
                    this.setState({ keyExistsInCloud: true });
                }
                else{
                    this.setState({ editForm: true });
                }
            }).catch(err => {
                error_manager("Failed (Check Internet Connection)", err)
            });
        this.props.dispatch(loadUsers());
        this.fetchDevices();
    }

    fetchDevices = () => get_response('/api/device/')
        .then(response => this.setState({all_devices: response.data}))
        .catch(error => error_manager("Failed to fetch devices", error));


    handleSubmitUserCreation = () => {

        if (this.state.customerName === "" || this.state.userName === "" || this.state.groupName === "" ||
            this.state.organisationName === "" || this.state.firstName === "" || this.state.password === "" ||
            this.state.deviceDisplayName === "" || isNull(this.device_for_user) || isNull(this.serial_number)) {
            message.error("Please fill all the fields")
            return;
        }

        if (this.state.createAdminUser && (this.state.adminUsername === "" || this.state.adminPassword === "")) {
            message.error("Please fill admin username and password or disable admin user creation.")
            return;
        }

        const formData = {
            deviceDisplayName: this.state.deviceDisplayName,
            customerName: this.state.customerName,
            userName: this.state.userName,
            groupName: this.state.groupName,
            organisationName: this.state.organisationName,
            firstName: this.state.firstName,
            password: this.state.password,
            createAdminUser: this.state.createAdminUser,
            adminUsername: this.state.adminUsername,
            adminPassword: this.state.adminPassword,
            deviceId: this.device_for_user,
            serialNumber: this.serial_number
        };
        const url = "/api/create_users_setup/";
        post(url, formData)
            .then(response => { 
                message.success(response)
            }).catch(err => {
                if (err?.response?.data) {
                    error_manager(err.response.data, err, 10)
                } else {
                    error_manager("Failed - reason unknown ", err, 10)
                }
            });
    }

    handleSubmitCloudSetup = () => {
        if (isNull(this.user_id_cloud) || isNull(this.cloud_provider) || isNull(this.bucket_name) ||
            isNull(this.region_name) || isNull(this.subfolder_name || isNull(this.device_for_cloud))) {
            message.error("Please fill fields related to cloud")
            return;
        }

        const formData = {
            allowedCloudUploads: this.state.allowedCloudUploads,
            overrideExistingUser: this.state.overrideExistingUser,
            cloudProvider: this.cloud_provider,
            cloudBucketName: this.bucket_name,
            cloudRegionName: this.region_name,
            cloudSubfolderName: this.subfolder_name,
            userId: this.user_id_cloud,
            deviceId: this.device_for_cloud
        };
        const url = "/api/create_cloud_setup/";
        post(url, formData)
            .then(response => {
                message.success(response)
            }).catch(err => {
            if (err?.response?.data) {
                message.error(err.response.data, 10)
            } else {
                message.error("Failed - reason unknown ", 10)
            }
        });
    }

    render() {
        return (
            <div id="scanner-div">
                <Row>
                    <Col className="scanner-name arial-font" span={24}>
                        {"SETUP WIZARD"}
                    </Col>
                </Row>
                {this.state.editForm ?
                    <Row>
                        <Col span={12}>
                            <Row>
                                <Col style={{fontSize: '18px', fontWeight: 'bold'}} span={24}>
                                    {"USER SETUP"}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    fontWeight: 'bold',
                                    verticalAlign: 'left'
                                }}>{" Device: "}</Col>
                                <Select showSearch optionFilterProp="children" onChange={value => this.device_for_user = value} style={{width: 300}}>
                                    {this.state.all_devices.map((key, _) => {
                                        return <Select.Option value={key.id}>{key.scanner_name}</Select.Option>
                                    })
                                    }
                                </Select>
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <Divider><Typography style={{fontSize: '12px'}}>Device Setup Section</Typography></Divider>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Device Display Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.deviceDisplayName}
                                    onChange={(e) => this.setState({deviceDisplayName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Device Serial No. : "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    onChange={e => this.serial_number = e.target.value}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Customer Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.customerName}
                                    onChange={(e) => this.setState({customerName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Group Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.groupName}
                                    onChange={(e) => this.setState({groupName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Organization Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.organisationName}
                                    onChange={(e) => this.setState({organisationName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <Divider><Typography style={{fontSize: '12px'}}>User Creation Section</Typography></Divider>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" User Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.userName}
                                    onChange={(e) => this.setState({userName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" First Name: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.firstName}
                                    onChange={(e) => this.setState({firstName: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Password: "}</Col>
                                <Input
                                    // type="password"
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.password}
                                    onChange={(e) => this.setState({password: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <Divider><Typography style={{fontSize: '12px'}}>Admin User Creation Section</Typography></Divider>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={10} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Create Admin User: "}</Col>
                                <Radio.Group
                                    value={this.state.createAdminUser}
                                    style={{textAlign: 'center'}}
                                    onChange={(e) => this.setState({createAdminUser: e.target.value})}
                                >
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Row>
                            <br></br>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Admin Username: "}</Col>
                                <Input
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.adminUsername}
                                    onChange={(e) => this.setState({adminUsername: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    verticalAlign: 'left'
                                }}>{" Admin Password: "}</Col>
                                <Input
                                    // type="password"
                                    style={{width: 'calc(100% - 200px)', verticalAlign: 'right'}}
                                    value={this.state.adminPassword}
                                    onChange={(e) => this.setState({adminPassword: e.target.value})}
                                />
                            </Row>
                            <Row>
                                <Col span={20} style={{ fontSize: '18px', textAlign: 'left', verticalAlign: 'left' }}>
                                    <b> NOTE:</b>
                                    {" Make Sure User Name And Group Name are Different"}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button type="primary" onClick={this.handleSubmitUserCreation}>Create Local user</Button>
                                </Col>
                            </Row>

                        </Col>
                        <Col span={10}>
                            <Row>
                                <Col style={{fontSize: '18px', fontWeight: 'bold'}} span={24}>
                                    {"CLOUD SETUP"}
                                </Col>
                            </Row>
                            <Row>
                                <Col span={7} style={{
                                    fontSize: '14px',
                                    textAlign: 'left',
                                    fontWeight: 'bold',
                                    verticalAlign: 'left'
                                }}>{" Device: "}</Col>
                                <Select showSearch optionFilterProp="children" onChange={value => this.device_for_cloud = value} style={{width: 250}}>
                                    {this.state.all_devices.map((key, _) => {
                                        return <Select.Option value={key.id}>{key.scanner_name}</Select.Option>
                                    })
                                    }
                                </Select>
                            </Row>
                            <Row>
                                <Col span={7} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" User for cloud Upload: "}</Col>
                                <Select showSearch optionFilterProp="children" onChange={value => this.user_id_cloud = value} style={{ width: 250 }}>
                                    {Object.values(this.props.users).map(data => {
                                        return <Select.Option value={data.id}>{data.username}</Select.Option>
                                    })
                                    }
                                </Select>
                            </Row>
                            <Row>
                                <Col span={7} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" Allowed Cloud Uploads: "}</Col>
                                <Col span={10}>
                                    <InputNumber
                                        style={{ width: 250, verticalAlign: 'right' }}
                                        value={this.state.allowedCloudUploads}
                                        onChange={(value) => this.setState({ allowedCloudUploads: value })}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={16}>
                                    <Divider><Typography style={{fontSize: '12px'}}>Cloud Storage Config Section</Typography></Divider>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={7} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" Cloud Provider: "}</Col>
                                <Select onChange={value => this.cloud_provider = value} style={{ width: 250 }}>
                                    <Select.Option value={cloudProvider.AWS}>AWS</Select.Option>
                                    <Select.Option value={cloudProvider.GCLOUD}>GCLOUD</Select.Option>
                                </Select>
                            </Row>
                            <Row>
                                <Col span={20} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" Bucket Name: "}</Col>
                                <Input onChange={e => this.bucket_name = e.target.value} style={{ width: 'calc(100% - 200px)', verticalAlign: 'right' }} />
                            </Row>
                            <Row>
                                <Col span={20} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" Region Name: "}</Col>
                                <Input onChange={e => this.region_name = e.target.value} style={{ width: 'calc(100% - 200px)', verticalAlign: 'right' }} />
                            </Row>
                            <Row>
                                <Col span={20} style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'left' }}>{" Subfolder name: "}</Col>
                                <Input onChange={e => this.subfolder_name = e.target.value} style={{ width: 'calc(100% - 200px)', verticalAlign: 'right' }} />
                            </Row>
                            <Col span={20} style={{fontSize: '18px', textAlign: 'left', verticalAlign: 'left'}}>
                                <b> NOTE:</b>
                                {" If cloud config already exists, Do you Wish to Override it?"}
                            </Col>
                            <Row>
                                <Col span={7} style={{ fontSize: '20px', textAlign: 'left', verticalAlign: 'left' }}></Col>
                                <Radio.Group
                                    value={this.state.overrideExistingUser}
                                    style={{ textAlign: 'center' }}
                                    onChange={(e) => this.setState({ overrideExistingUser: e.target.value })}
                                >
                                    <Radio value={true} >Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Row>
                            <br />
                            <Row>
                                <Col>
                                    <Button type="primary" onClick={this.handleSubmitCloudSetup}>Cloud Setup</Button>
                                </Col>
                            </Row>
                            <br /><br />
                            <Row>
                                <Typography>1. Bucket Name - Closest bucket to the customer, a valid AWS bucket, already created.</Typography>
                                <Typography>2. Region Name - region name for the bucket (Region where bucket is located.) Eg. ap-south-1</Typography>
                                <Typography>3. Subfolder Name - if customer has a subfolder in the bucket, mention it. If not leave it blank.</Typography>
                                <Typography>4. Bucket Naming Conventions - </Typography>
                                <Typography> 4.1. bucket name -->  mcloud-us-east-1   subfolder name -->  "user-name"</Typography>
                                <Typography> 4.2. bucket name -->  mcloud-USER-"user-name"   subfolder name -->  ""</Typography>
                                <Typography> 4.3. names can be either like 4.1 or 4.2 . If keyword USER is present in bucket, no subfolder will be considered. The bucket belongs to the user privately.</Typography>
                                <Typography> 4.4 If bucket does not exist, create a bucket on aws first. Buckets are not created automatically.</Typography>
                                <Typography> 4.5 However, subfolders will be created automatically.</Typography>
                            </Row>
                        </Col>
                    </Row>
                    : null}

                {this.state.keyExistsInCloud && !this.state.hideModal && <Modal
                        title="Cloud Setup Already Done"
                        visible={this.state.keyExistsInCloud}
                        onOk={() => this.setState({ editForm: true , hideModal: true })}
                        onCancel={() => this.setState({ editForm: false, hideModal: true })}
                    >
                        <p>Do you wish to override the existing cloud setup?</p>
                    </Modal>}
            </div>
        )
    }
}



const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer,
        users: state.caseStatusReducer.users,
    };
};

export default connect(mapStateToProps)(CreateUser);
